import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetContractModel } from "@factory/model/query-model-contract";
import { contractFormDefault } from "./form.default";
import { ContractFormSchema } from "./form.rule";

export const useFormDefaultContract = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetContractModel | undefined) => {
    return !cachedValue
      ? contractFormDefault
     : ({
        tenant: cachedValue.tenant,
        patient: cachedValue.patient,
        service: cachedValue.service,
        signature: cachedValue.signature,
        amount: cachedValue.amount,
      } as ContractFormSchema);
  };

  return {
    getDefault,
  };
};
